export default {
  common: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    loading: "拼命加载中",
    empty: "暂无数据",
    downloadFilename: "数据明细",
  },
  columns: {
    action: "操作",
    client: "客户端",
    state: "状态",
    updateTime: "更新时间",
    paymentMethod: "收款方式",
    paymentDetail: "收款详情",
    bankCard: "银行卡号/账号",
    bankBranch: "银行支行",
    bankName: "银行名称",
  },
};
